'use client';

import React from 'react';

interface DrawerProps {
  isOpen: boolean;
  drawerComponent: React.ReactNode;
  onCloseDrawer?: () => void;
}

/**
 * [SDヘッダー]ドロワーコンポーネント(上から下へ表示するドロワー)
 * @param param0
 * @returns
 */
const SdHeaderDrawerFromLeft: React.FC<DrawerProps> = ({ isOpen, drawerComponent, onCloseDrawer }) => {
  // コンテンツ外領域クリック時、ドロワークローズ
  const handleDrawerClose = () => {
    onCloseDrawer && onCloseDrawer();
  };

  // コンテンツ領域クリックした際、ドロワークローズ処理が伝播されないようにする
  const handleInnerClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black opacity-25 z-20" onClick={handleDrawerClose}></div>}

      <div
        className={`fixed inset-y-0 z-20 select-none left-0 w-[80dvw] transform transition-transform duration-200 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        onClick={handleDrawerClose}>
        <div onClick={handleInnerClick}>{drawerComponent}</div>
      </div>
    </>
  );
};

export default SdHeaderDrawerFromLeft;
